import type { JSX } from 'react';

import { cx } from '@emotion/css';
import { ErrorCode } from 'src/constants';
import { ClientServicesLink } from 'src/lib';

import { Font, Spacing } from '../styles';

export const renderTradingBlockPasswordExpirationErrorMessage = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return (
    <div>
      For security purposes My IPO requires your password to be changed once a year. To change your password, please
      click on
      <a className={cx(Spacing.p4, Font.lg)} onClick={onClick}>
        reset password
      </a>
      <span>.</span>
    </div>
  );
};

export const renderTooManyFailedLoginAttemptsErrorMessage = (): JSX.Element => {
  return (
    <div>
      You have reached the maximum number of log in attempts. Your account has been temporarily locked. Please contact
      My IPO at <ClientServicesLink /> to find out more information.
    </div>
  );
};

export const renderTooManyLoginAttemptsErrorMessage = (): JSX.Element => {
  return (
    <div>
      Your account has been temporarily locked due to an unusually high number of log in attempts. Please contact My IPO
      at <ClientServicesLink /> to find out more information.
    </div>
  );
};

export const renderGoogleRecaptchaValidationErrorMessage = (code?: ErrorCode): JSX.Element => {
  return (
    <div>
      Unknown error occurred while verifying reCAPTCHA {code ? `(Error code: ${code})` : ''}. Please try again later. If
      the problem persists, please try refreshing the page or contact <ClientServicesLink />.
    </div>
  );
};
